import { ColumnDescription, SelectRowProps } from "react-bootstrap-table-next";
import Table from "../../../../../../Components/Table";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp } from "@fortawesome/free-solid-svg-icons";
import {
    usuarioGrupo,
    vincularUsuarioGrupo,
} from "../../../../../../Interfaces/Geral/Grupos/GruposUsuarioInterface";
import OrSpinner from "../../../../../../Components/Utils/OrSpinner";
import { MutableRefObject } from "react";

interface IUsuariosDesvinculadosPorGrupo {
    lstUsuariosPorGrupoNaoVinculados: usuarioGrupo[] | undefined;
    lstUsuariosPorGrupoNaoVinculadosLoading: boolean;
    VincularGruposUsuario: (props: vincularUsuarioGrupo[]) => Promise<any>;
    VincularGruposUsuarioLoading: boolean;
    idGrupo: number;
    handleVincularUsuariosPorGrupo(): void;
    lstUsuarioPorGrupoLoading: boolean;
    ListarUsuariosPorGrupo: (...args: any[]) => Promise<usuarioGrupo[]>;
    ListarUsuariosPorGrupoNaoVinculados: (
        ...args: any[]
    ) => Promise<usuarioGrupo[]>;
    lstSelecionadosVinculados: MutableRefObject<usuarioGrupo[]>;
    updateUsers: (idGrupo: number) => void;
}

export default function UsuariosDesvinculadosPorGrupo(
    props: IUsuariosDesvinculadosPorGrupo
) {
    const columns: Array<ColumnDescription> = [
        {
            dataField: "DS_NOME",
            text: "Usuários Desvinculados",
        },
        {
            dataField: "ID_USUARIO",
            text: "",
            isDummyField: true,

            formatter: (_, row) => (
                <div className="Button-Tools d-flex justify-content-center align-items-center">
                    <button
                        className="btn btn-outline-success font-weight-bold mr-2"
                        onClick={() => {
                            props
                                .VincularGruposUsuario([
                                    {
                                        ID_GRUPO: props.idGrupo,
                                        ID_USUARIO: row.ID_USUARIO,
                                    },
                                ])
                                .then(() => {
                                    props.ListarUsuariosPorGrupoNaoVinculados();
                                    props.ListarUsuariosPorGrupo();
                                    props.updateUsers(props.idGrupo);
                                });
                        }}
                        disabled={props.VincularGruposUsuarioLoading}
                    >
                        <FontAwesomeIcon
                            icon={faArrowUp}
                            size="lg"
                            className="mr-2"
                        />{" "}
                        Vincular
                    </button>
                </div>
            ),
        },
    ];

    const selectRowProp: SelectRowProps<usuarioGrupo> = {
        mode: "checkbox",
        clickToSelect: true,
        selected: props.lstSelecionadosVinculados.current.map((p) => p.DS_NOME),

        onSelect: (row, isSelect) => {
            row.FL_ATIVO = isSelect;
            const lstAtributosMarcados =
                props.lstUsuariosPorGrupoNaoVinculados?.filter(
                    (p) => p.FL_ATIVO
                ) ?? [];

            props.lstSelecionadosVinculados.current = lstAtributosMarcados;
        },

        onSelectAll: (isSelect, rows: Array<usuarioGrupo>) => {
            rows.forEach((row) => {
                row.FL_ATIVO = isSelect;
            });

            props.lstSelecionadosVinculados.current =
                props.lstUsuariosPorGrupoNaoVinculados?.filter(
                    (p) => p.FL_ATIVO
                ) ?? [];
        },
    };

    return (
        <OrSpinner
            loading={
                props.lstUsuariosPorGrupoNaoVinculadosLoading ||
                props.VincularGruposUsuarioLoading
            }
            spinner="capys"
        >
            <>
                <Table
                    data={props.lstUsuariosPorGrupoNaoVinculados ?? []}
                    columns={columns}
                    keyField="ID_USUARIO"
                    selectRow={selectRowProp}
                    noDataIndication={
                        <div className="text-center text-muted">
                            Nenhum Usuário
                        </div>
                    }
                    loading={
                        props.lstUsuariosPorGrupoNaoVinculadosLoading ||
                        props.lstUsuarioPorGrupoLoading
                    }
                    wrapperClasses="wrapperTable mw-100 x-scroll"
                    classes="tableClasses"
                    bordered={false}
                    center
                    defaultStyle={{
                        align: "center",
                        classes: "p-2",
                    }}
                />
                <div className="d-flex col-12 justify-content-center mb-3">
                    <button
                        className="btn btn-outline-success"
                        onClick={() => props.handleVincularUsuariosPorGrupo()}
                        disabled={props.VincularGruposUsuarioLoading}
                    >
                        Vincular Selecionados
                    </button>
                </div>
            </>
        </OrSpinner>
    );
}
